import React from 'react'
import { Grid } from "@mui/material"
import { useSignal } from "@preact/signals-react"
import { scrollToComponent } from "@ui-seeker/utils"

import AlertsMileage from "Pages/ReportsAlerts/Alerts/Conditions/@components/MoreFeatures/Mileage"
import AlertsFuelPolicy from "Pages/ReportsAlerts/Alerts/Conditions/@components/MoreFeatures/FuelPolicy"
import AlertsAirportLocation from "Pages/ReportsAlerts/Alerts/Conditions/@components/MoreFeatures/AirportLocation"
import AlertsTransmission from "Pages/ReportsAlerts/Alerts/Conditions/@components/MoreFeatures/Transmission"
import { AppAntSwitch } from "@components"
import { alertsDrawerData } from "Pages/ReportsAlerts/Alerts/Conditions/@signals"

export default function AlertsMoreFeatures() {

	const showOptions = useSignal(
		alertsDrawerData.peek().mileage ||
		alertsDrawerData.peek().fuelPolicy ||
		alertsDrawerData.peek().airportLocation ||
		alertsDrawerData.peek().transmission
	)

	return <Grid container spacing={3}>
		<Grid item xs={12}>
			<AppAntSwitch
				trueText="More features"
				checked={showOptions.value}
				onChange={e => {
					showOptions.value = e.target.checked
					setTimeout(() => {
						scrollToComponent("scrollToFeatures")
					}, 100)
				}}
			/>
		</Grid>
		{showOptions.value && <>
			<Grid item xs={6}>
				<AlertsMileage/>
			</Grid>
			<Grid item xs={6}>
				<AlertsFuelPolicy/>
			</Grid>
			<Grid item xs={6}>
				<AlertsAirportLocation/>
			</Grid>
			<Grid item xs={6}>
				<AlertsTransmission/>
			</Grid>
			<Grid item xs={12} id="scrollToFeatures"/>
		</>}
	</Grid>
}